import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { urlEndPoint } from 'src/app/common';
import { Publication } from 'src/app/models/obs/publication';
import { PublicationService } from 'src/app/services/obs/publication.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';


@Component({
  selector: 'app-admpublications-form-pdf',
  templateUrl: './admpublications-form-pdf.component.html',
  styleUrl: './admpublications-form-pdf.component.scss'
})
export class AdmpublicationsFormPdfComponent implements OnInit {

  form: FormGroup;
  publication: Publication = null;

  edit: boolean = false;
  isUploadPdfDir: boolean = false;
  filenamePDF: string[] = [];//Nombres de los archivos que se guardan en la carpeta uploads y nos devuelve para mandarlo a base de datos
  tempfilenamePDF: string[] = [];//Almacenamos el nombre de archivo que ya tenemos en base de datos
  tempdirectoryPDF: string[] = [];//Alamacenamos el directorio del acrvhio que ya tenemos en base de datos
  URL: string = urlEndPoint;//Almacenamos lo que ya esta guardado en base de datos
  uploatedFilePDF: File[] = [];

  constructor(
    private router: Router,
    private publicationService: PublicationService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getPublication(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      doc: [null],
      doc_name: [null],
    })
  }

  updatetempfilenamePDF(index: number, newValue: string) {
    this.tempfilenamePDF[index] = newValue;
  }

  loadData() {
    this.form.reset(this.publication);
  }

  getPublication(params: any) {
    if (params.id) {
      this.publicationService.getOne(params.id).subscribe({
        next: res => {
          this.publication = res['data'];
          this.verifiedPdfDirectory();
          this.edit = true;
          this.loadData();
          this.loadpdf();
        },
        error: err => console.error(err)
      });
    } else {
      this.edit = false;
    }
  }


  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFilePDF != null) ? this.onUploadPDF() : this.saveOrUpdate();
    }
  }

  onUploadPDF() {
    const observables = [];

    if (this.uploatedFilePDF && this.uploatedFilePDF.length > 0) {
      for (const pdfFile of this.uploatedFilePDF) {
        const formDataPDF = new FormData();
        formDataPDF.append("uploads", pdfFile, pdfFile.name);
        observables.push(this.uploadS.uploadFilePubs(formDataPDF));
      }
    }

    if (observables.length > 0) {
      forkJoin(observables).subscribe({
        next: (responses) => {
          if (responses.length > 0) {
            for (let i = 0; i < this.uploatedFilePDF.length; i++) {
              this.filenamePDF[i] = responses[i].filename;
            }
          }
          this.saveOrUpdate();
        },
        error: (error) => {
          console.error(error);
        }
      });
    } else {
      this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/publicacion/list']);
  }

  update(id: string, publication: Publication) {
    delete publication.id;
    this.updatePublicationDocs(publication);
    this.publicationService.update(id, publication).subscribe({
      next: res => { console.log("res update: ", res) },
      error: err => { console.error(err) }
    });
  }

  create(publication: Publication) {
    delete publication.id;
    this.updatePublicationDocs(publication);
    this.publicationService.create(publication).subscribe({
      next: res => { console.log("res create: ", res) },
      error: err => { console.error(err) }
    });
  }

  //Metodo para recuperar los nombres y urls de cada docuemnto y enviarlo a guardar a la table publicaciones
  updatePublicationDocs(publication: Publication) {
    const sizeOnDb = this.tempdirectoryPDF.length
    if (this.filenamePDF) {
      if (this.tempfilenamePDF.length > 0) {
        publication.doc = [];
        publication.doc_name = [];
        for (let i = 0; i < this.tempdirectoryPDF.length; i++) {
          publication.doc[i] = this.tempdirectoryPDF[i];
          publication.doc_name[i] = this.tempfilenamePDF[i];
        }

        for (let i = 0; i < this.uploatedFilePDF.length; i++) {
          publication.doc[this.tempdirectoryPDF.length + i] = '/uploads/pubs/docs/' + this.filenamePDF[i];
          publication.doc_name[this.tempdirectoryPDF.length + i] = this.tempfilenamePDF[i + sizeOnDb];
        }
      } else {
        if (this.uploatedFilePDF.length == 0) {
          publication.doc = [];
          publication.doc_name = [];
        }
        for (let i = 0; i < this.uploatedFilePDF.length; i++) {
          publication.doc[i] = '/uploads/pubs/docs/' + this.filenamePDF[i];
          publication.doc_name[i] = this.tempfilenamePDF[i + sizeOnDb];
        }
      }
    }
  }

  cancel() {
    this.router.navigate(['/adm/publicacion/list']);
  }


  //aca empieza pdf

  verifiedPdfDirectory() {
    if (this.publication.doc && this.publication.doc.some((pdfPath) => pdfPath.startsWith('/uploads'))) {
      this.isUploadPdfDir = true;
    } else {
      this.isUploadPdfDir = false;
    }
  }

  loadpdf() {
    this.tempfilenamePDF = [];
    if (this.publication.doc && this.publication.doc.length > 0) {
      for (const pdfPath of this.publication.doc) {
        const pdfName = pdfPath.substring(pdfPath.lastIndexOf('/') + 1);
        if (pdfPath && pdfPath.trim() !== "") {
          this.filenamePDF.push(pdfName);
          this.tempdirectoryPDF.push(pdfPath);
        }
      }
    }

    if (this.publication.doc_name && this.publication.doc_name.length > 0) {
      for (const pdfPath of this.publication.doc_name) {
        if (pdfPath && pdfPath.trim() !== "") {
          this.tempfilenamePDF.push(pdfPath);
        }
      }
    }

  }

  onPdfChange(event: any) {
    const newSelectedPdfFiles = event.target.files;
    for (let i = 0; i < newSelectedPdfFiles.length; i++) {
      this.uploatedFilePDF.push(newSelectedPdfFiles[i]);
      this.tempfilenamePDF.push(newSelectedPdfFiles[i].name);
    }
  }

  removePdf(index: number) {
    if (this.tempdirectoryPDF[index]) {
      const pdfPath = this.tempdirectoryPDF[index];
      const parts = pdfPath.split('/');
      const filename = parts[parts.length - 1];

      const confirmation = confirm(`¿Estás seguro de que deseas eliminar el archivo "${filename}"?`);

      if (confirmation) {
        if (pdfPath.startsWith('/uploads')) {
          this.uploadS.deletedFilePubs(filename).subscribe(
            () => {
              this.tempdirectoryPDF.splice(index, 1);
              this.tempfilenamePDF.splice(index, 1);
              this.uploatedFilePDF.splice(index, 1);
              this.filenamePDF.splice(index, 1);
            },
            (error) => {
              console.error(`Error al eliminar el archivo: ${error}`);
            }
          );
        } else {
          this.tempdirectoryPDF.splice(index, 1);
          this.tempfilenamePDF.splice(index, 1);
          this.uploatedFilePDF.splice(index, 1);
          this.filenamePDF.splice(index, 1);
        }
      }
    }
  }


}
